module.exports = __webpack_public_path__ + "static/media/profile2.4216626c.jpg";